import {
    CompositeFilterDescriptor,
} from "@progress/kendo-data-query/dist/npm/filtering/filter-descriptor.interface";
import {clone} from "./functions";

export const emptyResponse = {"total": 0, "aggregates": null, "errors": null, "group": null, "data": []};

export interface Selector {
    values: any[],
    key: string,
    frontKey?: string,
    operator?: string
}

// export const kendoFilterToSelectorArr = (filter: CompositeFilterDescriptor | null): Selector[] => {
//     if (filter === null) return [];
//
//     const copy = clone(filter) as CompositeFilterDescriptor;
//
//     const entries = Object.entries(copy);
//     console.log({entries});
//
//     return [];
// };

export const buildKendoFilter = (arr: Selector[]): CompositeFilterDescriptor | null => {
    const rawArr = clone(arr) as Selector[];

    const withValues = rawArr
      .filter(x => x.values.length > 0) as Selector[];

    const res = withValues
      .reduce((acc: CompositeFilterDescriptor, curr) => {
          const currFilter: CompositeFilterDescriptor = {
              logic: "or",
              filters: curr.values.map(x => {
                  return {
                      field: curr.key,
                      operator: curr.operator || "eq",
                      value: curr.frontKey !== undefined ? x[curr.frontKey] : x[curr.key]
                  }
              })
          }
          acc.filters.push(currFilter);
          return acc;
      }, {
          logic: "and",
          filters: []
      });

    return res.filters.length === 0 ? null : res;
}
